import { _colors, getTheme as baseTheme } from './themes';

export const getButtonTheme = () => {
    const newTheme = baseTheme();
    newTheme.components.Button = {
        colorBgContainerDisabled: _colors.white1,
        colorTextDisabled: _colors.black2
    };

    return newTheme;
}